import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { style: { "position": "sticky", "z-index": "2", "top": "0" } };
const _hoisted_2 = { class: "mobileSidebarMenu" };
const _hoisted_3 = { class: "col-12 py-2 bg-brand_beige_hover" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "col-10" };
const _hoisted_7 = { class: "text-left strong font4 m-0 mb-n1 pb-0" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 0,
    class: "col-12 py-2"
};
const _hoisted_10 = {
    key: 1,
    class: "col-12 py-2"
};
const _hoisted_11 = { style: { "position": "absolute", "bottom": "0", "right": "0", "left": "0" } };
import eventBus from '@/services/EventBus';
import { ref, onMounted, computed } from 'vue';
import { useStore } from '@/store';
import MenuItems from '@/components/Menus/MenuItems.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MobileSidebarMenu',
    setup(__props) {
        onMounted(() => {
            eventBus.on('openMobileSidebarMenu', openMenuAndDoThings);
            eventBus.on('closeMobileSidebarMenu', closeMenu);
        });
        const store = useStore();
        const firstName = computed(() => { var _a; return (_a = store.state.account.currentUser) === null || _a === void 0 ? void 0 : _a.firstName; });
        const loggedIn = computed(() => store.state.account.currentUser !== null);
        const isAdmin = computed(() => { var _a; return (_a = store.state.account.currentUser) === null || _a === void 0 ? void 0 : _a.is_admin; });
        const openMenu = ref(false);
        const openMenuAndDoThings = () => {
            openMenu.value = true;
        };
        const closeMenu = () => {
            openMenu.value = false;
        };
        return (_ctx, _cache) => {
            const _component_open_popup_button = _resolveComponent("open-popup-button");
            const _component_customer_support_info = _resolveComponent("customer-support-info");
                                                                  
                                                                      
            return (_openBlock(), _createBlock(_component_v_dialog, {
                fullscreen: "",
                transition: "dialog-top-transition",
                persistent: false,
                class: "mobileMenu",
                modelValue: openMenu.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((openMenu).value = $event)),
                width: "480px",
                "max-width": "96vw",
                height: "100vh"
            }, {
                default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createElementVNode("nav", _hoisted_1, [
                                _createElementVNode("ul", _hoisted_2, [
                                    _createElementVNode("li", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            (!loggedIn.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _cache[2] || (_cache[2] = _createElementVNode("div", {
                                                        onclick: "eventBus.emit('closeMobileSidebarMenu'); eventBus.emit('openLoginPopup');",
                                                        "data-test": "cy-login-button",
                                                        class: "strong col-10 py-2 text-left hyphens-auto",
                                                        role: "button",
                                                        title: "Anmelden / Registrieren"
                                                    }, [
                                                        _createElementVNode("i", { class: "icon-brand_user font5 ml-n2" }),
                                                        _createTextVNode(" Registrieren / Anmelden ")
                                                    ], -1)),
                                                    _createElementVNode("div", {
                                                        onClick: ($event) => (isActive.value = false),
                                                        class: "col-2 d-flex align-items-center justify-content-end pl-1"
                                                    }, [...(_cache[1] || (_cache[1] = [
                                                            _createElementVNode("i", { class: "icon-cancel pointerhover" }, null, -1)
                                                        ]))], 8, _hoisted_5)
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (loggedIn.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createElementVNode("div", _hoisted_6, [
                                                        _createVNode(_component_open_popup_button, { "popup-name": "openMobileSidebarMyAccountMenu" }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("h2", _hoisted_7, [
                                                                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icon-brand_user ml-n2" }, null, -1)),
                                                                    _createTextVNode(" Moin " + _toDisplayString(firstName.value), 1)
                                                                ]),
                                                                _cache[4] || (_cache[4] = _createElementVNode("strong", { class: "text-underline font8" }, "Mein Konto", -1))
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _createElementVNode("div", {
                                                        onClick: ($event) => (isActive.value = false),
                                                        class: "col-2 d-flex align-items-center justify-content-end pl-1"
                                                    }, [...(_cache[5] || (_cache[5] = [
                                                            _createElementVNode("i", { class: "icon-cancel pointerhover" }, null, -1)
                                                        ]))], 8, _hoisted_8)
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    (isAdmin.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [...(_cache[6] || (_cache[6] = [
                                                _createElementVNode("a", {
                                                    class: "row",
                                                    href: "/admin",
                                                    title: "Shop-Admin Bereich"
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "col-10 p-0 text-left",
                                                        style: { "hyphens": "auto" }
                                                    }, [
                                                        _createElementVNode("span", { class: "fc-darkRed font-weight-bold" }, "SHOP ADMIN")
                                                    ])
                                                ], -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    _createVNode(MenuItems),
                                    (loggedIn.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                            _createVNode(_component_open_popup_button, {
                                                class: "row",
                                                "popup-name": "openMobileSidebarMyAccountMenu",
                                                "data-test": "cy_mobileSidebarSubmenu"
                                            }, {
                                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                        _createElementVNode("div", {
                                                            class: "col-10 p-2 pl-3 text-left",
                                                            title: "Mein Konto Bereich",
                                                            role: "button"
                                                        }, " MEIN KONTO ", -1)
                                                    ]))]),
                                                _: 1
                                            })
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_customer_support_info, { class: "bg-brand_deep_blue fc-white" })
                            ])
                        ]),
                        _: 2
                    }, 1024)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});


/* Vuetify */
import { VCard as _component_v_card } from "vuetify/components/VCard"
import { VDialog as _component_v_dialog } from "vuetify/components/VDialog"

